'use client';

import { type FC } from 'react';
import { Checkbox, Flex, Heading } from '@/_components';
import type { OptionsProps } from './Options.types';

export const Options: FC<OptionsProps> = ({
  convertAllImagesToPDF,
  selectedDMS,
  selectableDMS,
  format,
  includeTOC,
  includePageNumbers,
  includeDocuments,
  includeAnnotations,
  annotationEnabled,
  onIncludeDocumentsChange,
  removeAllNosAndNAs,
  setConvertAllImagesToPDF,
  setIncludePageNumbers,
  setIncludeTOC,
  setIncludeAnnotations,
  setRemoveAllNosAndNAs,
  toggleSelectedDMS,
}) => {
  return (
    <Flex isColumn={true} gap={4}>
      <Heading level={5}>Export options</Heading>
      <Checkbox
        label="Include table of contents"
        isChecked={includeTOC}
        onChange={(event) => setIncludeTOC(event.target.checked)}
      />

      {includeTOC && (
        <Checkbox
          label="Include page numbers"
          isChecked={includePageNumbers}
          onChange={(event) => setIncludePageNumbers(event.target.checked)}
        />
      )}

      <Checkbox
        label="Include documents"
        isChecked={includeDocuments}
        onChange={(event) => onIncludeDocumentsChange(event.target.checked)}
      />

      {(format === 'pdf' || format === 'zipped') &&
        annotationEnabled &&
        includeDocuments && (
          <Checkbox
            label="Include annotations on documents"
            isChecked={includeAnnotations}
            onChange={(event) => setIncludeAnnotations(event.target.checked)}
          />
        )}

      {format === 'pdf' && (
        <Checkbox
          label="Remove all 'No' and 'N/A' answers"
          isChecked={removeAllNosAndNAs}
          onChange={(event) => setRemoveAllNosAndNAs(event.target.checked)}
        />
      )}

      {format === 'zipped' && (
        <Checkbox
          label="Convert all images to PDF"
          isChecked={convertAllImagesToPDF}
          onChange={(event) => setConvertAllImagesToPDF(event.target.checked)}
        />
      )}

      {(format === 'pdf' || format === 'zipped') &&
        selectableDMS.map((dms) => (
          <Checkbox
            key={dms}
            label={'Export to third-party DMS'}
            isChecked={selectedDMS.includes(dms)}
            onChange={(event) => toggleSelectedDMS(dms, event.target.checked)}
          />
        ))}
    </Flex>
  );
};
